export const isNolsQuotation = (q?: { type?: string }) => q?.type === 'NolsQuotationDto'
export const isCzechiaQuotation = (q?: { type?: string }) => q?.type === 'CzechiaQuotationDto'
export const isFinlandQuotation = (q?: { type?: string }) => q?.type === 'FinlandQuotationDto'

export const isNolsDelivery = (d?: { type?: string }) => d?.type === 'NolsDeliveryDto'
export const isCzechiaDelivery = (d?: { type?: string }) => d?.type === 'CzechiaDeliveryDto'
export const isFinlandDelivery = (d?: { type?: string }) => d?.type === 'FinlandDeliveryDto'

export const isNolsOrder = (po?: { type?: string }) => po?.type === 'NolsOrderDto'
export const isSapOrder = (po?: { type?: string }) =>
  po?.type === 'CzechiaVehicleOrderDto' ||
  po?.type === 'FinlandVehicleOrderDto' ||
  po?.type === 'TyreOrderDto'
export const isVehicleOrder = (po?: { type?: string }) =>
  po?.type === 'CzechiaVehicleOrderDto' || po?.type === 'FinlandVehicleOrderDto'
